import type { ReactNode } from 'react';
import { useFacilityLicenses } from '../../api/licensesApi';
import NoAccess from './NoAccess';
import { PermissionsLoading } from './SessionLoadError';

export const PURCHASING_NOT_LICENSED = 'Purchasing is not part of this facility\'s subscription. Contact PSI to add it.';
export const PURCHASING_LICENCE_UNKNOWN = 'Could not check this facility\'s subscription. Please try again in a few minutes.';

/**
 * Blocks the purchasing pages unless Tech Log says the facility is licensed for purchasing
 * (Pur_Allow). Pair it with the API's PurchasingAccessFilter, which is what actually enforces it.
 * Fails closed: nothing renders while the licence is loading or if it could not be read.
 */
export default function PurchasingLicenseRoute({ children }: { children: ReactNode }) {
  const { data, isLoading, isError } = useFacilityLicenses();
  if (isLoading) return <PermissionsLoading />;
  if (isError || !data?.known) return <NoAccess feature="Purchasing" message={PURCHASING_LICENCE_UNKNOWN} />;
  if (!data.modules?.purchasing) return <NoAccess feature="Purchasing" message={PURCHASING_NOT_LICENSED} />;
  return <>{children}</>;
}
